import React from 'react';
import { useCurrencyDetection } from '../hooks/useCurrencyDetection';
interface PriceDisplayProps {
  amount: number;
  showOriginal?: boolean;
  originalAmount?: number;
  className?: string;
  originalClassName?: string;
}
export function PriceDisplay({
  amount,
  showOriginal = false,
  originalAmount,
  className = 'text-3xl md:text-4xl font-bold text-primary tracking-tight',
  originalClassName = 'text-lg md:text-xl text-text-primary/40 line-through font-bold'
}: PriceDisplayProps) {
  const {
    symbol,
    rate,
    code
  } = useCurrencyDetection();
  const convertedAmount = Math.round(amount * rate);
  const convertedOriginal = originalAmount ? Math.round(originalAmount * rate) : 0;
  const formatPrice = (val: number) => {
    if (code === 'ARS') {
      return val.toLocaleString('es-AR');
    }
    return val.toLocaleString();
  };
  return <div className="flex flex-col items-center justify-center gap-1" data-id="element-159">
      {showOriginal && originalAmount && <span className={originalClassName} data-id="element-160">
          {symbol}
          {formatPrice(convertedOriginal)} {code}
        </span>}
      <span className={className} data-id="element-161">
        {symbol}
        {formatPrice(convertedAmount)} {code}
      </span>
    </div>;
}